import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Plus, DotsSixVertical, X, CaretUp } from '@phosphor-icons/react'
import { useSortable } from '@dnd-kit/react/sortable'

import ToggleField from '../../FormLegacy/FormFieldsV2/ToggleField'
import TextField from '../../FormLegacy/FormFieldsV2/TextField'
import { getDraggableStyle } from '../helpers'

const RoomItem = ({
  values,
  room,
  index,
  selectedId,
  selectedIndex,
  onCollapse = () => {},
  onEditLocation = () => {},
  onRemoveLocation = () => {},
  getLocationError = () => {},
  onAddQuestion = () => {},
  onChangeQuestion = () => {},
  onRemoveQuestion = () => {},
}) => {
  const { t } = useTranslation(['internal-inspections'])
  const { ref, isDragging } = useSortable({ id: room.id, index })

  return (
    <div
      ref={ref}
      style={getDraggableStyle(isDragging)}
      className={`setup-location ${room.id === selectedId ? 'collapsed' : ''}`}
    >
      <div className="setup-location__head">
        <div>
          <div role="button">
            <DotsSixVertical className="dots" />
          </div>
          <span>{index + 1}.</span>
          <TextField
            additionalClass="editable-input"
            name="name"
            onChange={(e) => onEditLocation(room.id, 'name', e.target.value)}
            value={room.name}
            isError={!!getLocationError(selectedIndex, index, 'name')}
            errorLabel={getLocationError(selectedIndex, index, 'name')}
          />
        </div>
        <div>
          <div role="button" onClick={() => onRemoveLocation(room.id)}>
            <X className="cross" />
          </div>
          {values.guided && (
            <div role="button" onClick={() => onCollapse(room.id)}>
              <CaretUp className="caret" />
            </div>
          )}
        </div>
      </div>
      {values.guided && room.id === selectedId && (
        <div className="setup-location__content">
          <div className="description-setup">
            <span className="input-label">
              {t('internal-inspections:roomItem.descriptionInstruction')}
            </span>
            <TextField
              name="description"
              placeholder={t('internal-inspections:roomItem.writeDescriptionPlaceholder')}
              onChange={(e) => onEditLocation(room.id, 'description', e.target.value)}
              value={room.description}
            />
          </div>
          <div className="options-setup">
            <div>
              <ToggleField
                name="requirePhoto"
                label={t('internal-inspections:roomItem.requirePhoto')}
                labelOnRight
                value={room.requirePhoto}
                onChange={() => onEditLocation(room.id, 'requirePhoto', !room.requirePhoto)}
              />
              <ToggleField
                name="requireRating"
                label={t('internal-inspections:roomItem.conditionRating')}
                labelOnRight
                value={room.requireRating}
                onChange={() => onEditLocation(room.id, 'requireRating', !room.requireRating)}
              />
              <ToggleField
                name="requireNote"
                label={t('internal-inspections:roomItem.note')}
                labelOnRight
                value={room.requireNote}
                onChange={() => onEditLocation(room.id, 'requireNote', !room.requireNote)}
              />
            </div>
            {!!getLocationError(selectedIndex, index) && (
              <span className="input-label--error">{getLocationError(selectedIndex, index)}</span>
            )}
          </div>
          <span className="input-label">{t('internal-inspections:roomItem.advancedSettings')}</span>
          <div className="questions-list">
            {room.questions.map((question, questionIndex) => (
              <div key={question.id} className="question-item">
                <span>{questionIndex + 1}.</span>
                <TextField
                  name="question"
                  additionalClass="editable-input"
                  onChange={(e) => onChangeQuestion(question.id, e.target.value)}
                  value={question.question}
                  isError={
                    !!getLocationError(selectedIndex, index, `questions[${questionIndex}].question`)
                  }
                  errorLabel={getLocationError(
                    selectedIndex,
                    index,
                    `questions[${questionIndex}].question`,
                  )}
                />
                <div role="button" onClick={() => onRemoveQuestion(question.id)}>
                  <X className="cross" />
                </div>
              </div>
            ))}
          </div>
          <div className="add-question" role="button" onClick={onAddQuestion}>
            <Plus />
            <span>{t('internal-inspections:roomItem.addCustomQuestion')}</span>
          </div>
        </div>
      )}
    </div>
  )
}

RoomItem.propTypes = {
  values: PropTypes.object,
  room: PropTypes.object,
  index: PropTypes.number,
  selectedId: PropTypes.string,
  selectedIndex: PropTypes.number,
  onCollapse: PropTypes.func,
  onEditLocation: PropTypes.func,
  onRemoveLocation: PropTypes.func,
  onAddQuestion: PropTypes.func,
  onRemoveQuestion: PropTypes.func,
  onChangeQuestion: PropTypes.func,
  getLocationError: PropTypes.func,
}

export default RoomItem
